


















import { Component, Vue, Watch } from "vue-property-decorator";
import SubmitButton from "@/components/SubmitButton.vue";
import { client } from "@/api/request";

@Component({
  components: {
    SubmitButton
  }
})
export default class WorkerViewAllServiceTasks extends Vue {
  status: boolean = false;

  get viewAllServiceTasks(): boolean {
    return this.$store.state.service.viewAllServiceTasks;
  }

  @Watch("viewAllServiceTasks", { immediate: true })
  onServiceChanged(newValue: boolean) {
    this.status = newValue;
  }

  public async submit() {
    const param = {
      viewAllServiceTasks: this.status
    };
    try {
      await client.post("save_worker_view_all_service_tasks.php", param);
      this.$store.dispatch("setViewallServiceTask", this.status);
    } catch (error) {
      this.status = !this.status;
    }
  }
}
